import { render, staticRenderFns } from "./share-content.vue?vue&type=template&id=d98c0b7e&scoped=true&"
import script from "./share-content.vue?vue&type=script&lang=js&"
export * from "./share-content.vue?vue&type=script&lang=js&"
import style0 from "./share-content.vue?vue&type=style&index=0&id=d98c0b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98c0b7e",
  null
  
)

export default component.exports